import { render, staticRenderFns } from "./ApprovalClaimCreateAction.vue?vue&type=template&id=7be6c3f1"
import script from "./ApprovalClaimCreateAction.vue?vue&type=script&lang=js"
export * from "./ApprovalClaimCreateAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports